import { render, staticRenderFns } from "./companyNotice.vue?vue&type=template&id=314e091d&scoped=true"
import script from "./companyNotice.vue?vue&type=script&lang=js"
export * from "./companyNotice.vue?vue&type=script&lang=js"
import style0 from "./companyNotice.vue?vue&type=style&index=0&id=314e091d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314e091d",
  null
  
)

export default component.exports